import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TaggingComponent } from './views/pages/tagging/tagging.component';
import { LoginComponent } from './views/pages/login/login.component';


const routes: Routes = [
  { path: 'tagging', component: TaggingComponent },
  { path: '', component: LoginComponent },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
